/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для группы форм доставки
   */
  app.JointPurchaseDeliveryFormsView = app.View.extend({
    el: '',

    templateName: '',

    firstRender: true,

    isRemoved: false,

    run: function (options) {
      if (options && options.settlement) {
        this.settlement = options.settlement;
      }
      if (options && options.parentView) {
        this.parentView = options.parentView;
      }
      if (options && options.districts !== null) {
        this.districts = new app.Districts(options.districts);
      } else {
        this.districts = new app.Districts();
        if (this.settlement) {
          this.fetchDistricts();
        }
      }
      this.jpDistrictModels = new app.Districts();
      this.template = app.helpers.TemplateHelper.getTemplate(this.templateName);
      this.childViews = {};
      this.render();
      this.listenTo(this.model, 'add', this.renderNewDeliveryForm);
      this.listenTo(this.model, 'add remove', this.toggleButtons);
      this.listenTo(this.model, 'remove', this.toggleButtons);
    },

    render: function () {
      var that = this;
      var element = $(this.template({
        settlement: this.settlement,
        model: this.districts.length ? null : this.model.at(0),
        hasDistricts: !!this.districts.length,
      }));
      this.childViews.formViews = [];
      if (this.firstRender) {
        this.firstRender = false;
      } else {
        this.$el.replaceWith(element);
      }
      this.setElement(element);
      _.each(this.model.models, function (model) {
        that.renderNewDeliveryForm(model, that.model);
      });
      this._initChildViews();
      this.toggleButtons();
      return element;
    },

    _initChildViews: function () {
      this.settlementAutocomplete = new app.SettlementAutocompleteView({
        el: this.$('.checkout-city'),
        excludeSettlementIds: this.parentView.jpSettlementIds,
        settlement: this.settlement,
      });
      this.listenTo(this.settlementAutocomplete, 'autocompleteDone', this.triggerChangeOnCityInputAndFetchDistricts);
    },

    /**
     * Изменение населенного пункта для группы доставки
     *
     * @param settlementId
     * @param model
     */
    triggerChangeOnCityInputAndFetchDistricts: function (settlementId, model) {
      if (model) {
        this.settlement = model.toJSON();
        this.destroyModels();
        this.fetchDistricts();
      }
    },

    /**
     * Загружает список районов для выбранного населенного пункта
     */
    fetchDistricts: function () {
      this.districts.fetch({
        data: $.param({settlement_id: this.settlement.id || this.settlement.settlement_id}),
        success: this._districtSuccess.bind(this),
      });
    },

    _districtSuccess: function () {
      this.addDeliveryDistrict();
      this.parentView.updateGroupsData();
      this.render();
    },

    /**
     * Удаляет группу доставки
     */
    deleteGroupForms: function () {
      this.destroyModels();
      this.isRemoved = true;
      this.parentView.updateGroupsData();
      this.remove();
    },

    /**
     * Удаляет все записи из группы доставки
     */
    destroyModels: function () {
      var model = this.model.first();
      while (model) {
        model.destroy();
        model = this.model.first();
      }
    },

    /**
     * Метод для вызова метода save у всех дочерних view.
     */
    validateAll: function () {
      var deferred = [];
      if (this.childViews.formViews.length) {
        this.childViews.formViews.forEach(function (view) {
          if (!view.isRemoved) {
            deferred.push(view.save(true));
          }
        });
        return $.when.apply($, deferred);
      } else {
        return;
      }
    },
  });
})();

}.call(window));